import React from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchOffIcon from '@mui/icons-material/SearchOff';

export default function NotFound() {
  const navigate = useNavigate();

  const goHome = () => {
    // Se autenticado, vai pra home; caso contrário o guard/redirect
    // do login trata. Simples: reencaminhar sempre pra /home é OK
    // porque a tela pública é / e não bate com nada relevante aqui.
    navigate(localStorage.getItem('token') ? '/home' : '/');
  };

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}
    >
      <Stack spacing={3} alignItems="center" textAlign="center" maxWidth={520}>
        <SearchOffIcon sx={{ fontSize: 96, color: 'text.disabled' }} />

        <Stack spacing={1}>
          <Typography variant="h3" component="h1" fontWeight={600}>
            404
          </Typography>
          <Typography variant="h5" component="p" fontWeight={500}>
            Página não encontrada
          </Typography>
          <Typography variant="body1" color="text.secondary">
            O endereço acessado não existe ou foi movido. Verifique se o
            link está correto ou volte para o início do painel.
          </Typography>
        </Stack>

        <Button
          variant="contained"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={goHome}
        >
          Voltar ao início
        </Button>
      </Stack>
    </Box>
  );
}
